import React, { useEffect, useState, forwardRef } from 'react';

import {
    Box,
    Typography,
    Tabs,
    Tab,
    Table,
    TableHead,
    TableCell,
    TableRow,
    TableBody,
    TableContainer,
} from '@mui/material';

import { useSystemUtils } from "../../hooks/useSystemUtils"
import { useTranslations } from "../../hooks/useTranslations";
import { useDocumentAdjustments, adjustmentTypes } from '../../hooks/state/useDocumentAdjustments';

export default function ViewDocumentFooter({
    data,
    showTax = false,
    showDiscount = true,
    showSubTotal = true,
    showTotalAmount = true,
    customRows = [],
}) {
    const { t } = useTranslations({ ns: ["common", "@document"] })

    const { formatCurrencyDisplay, currencyAbb } = useSystemUtils();

    if (!data) return <></>

    let adjustment = data?.document?.adjustments ? data.document.adjustments : []
    // let discountAmount= data?.document?.discount_amount

    // console.log('adjustment', adjustment)

    let adjustmentDiscountInfo = []
    let adjustmentTaxInfo = []
    let adjustmentRoundingCredit = []
    let adjustmentRoundingDebit = []

    adjustment.forEach(i => {
        if (i.type === adjustmentTypes.tax) {
            adjustmentTaxInfo.push({
                taxId: i.id,
                taxDescription: i.description,
                taxAmount: parseFloat(i.adjustment_amount).toFixed(2)
            })
        }
        else if (i.type === adjustmentTypes.discount) {
            adjustmentDiscountInfo.push({
                discountId: i.id,
                discountDescription: i.description,
                discountAmount: parseFloat(i.adjustment_amount).toFixed(2)
            })
        }
        else if (i.type === adjustmentTypes.roundingCredit) {
            adjustmentRoundingCredit.push({
                roundingId: i.id,
                roundingDescription: i.description,
                roundingAmount: parseFloat(i.adjustment_amount).toFixed(2)
            })
        }
        else if (i.type === adjustmentTypes.roundingDebit) {
            adjustmentRoundingDebit.push({
                roundingId: i.id,
                roundingDescription: i.description,
                roundingAmount: parseFloat(i.adjustment_amount).toFixed(2)
            })
        }
    })

    // console.log('Tax Info', adjustmentTaxInfo)

    return (
        <TableContainer
            // component={Paper}
            sx={{
                // mt: 1
                // minHeight: 400,
                // maxHeight: 400
            }}
        >
            <Table
                size="small"
            // stickyHeader
            >
                <TableBody>
                    {
                        showSubTotal &&
                        <TableRow>
                            <TableCell align="right" width={'90%'}>{t('subTotal')}</TableCell>
                            <TableCell align="right">{formatCurrencyDisplay(data?.document?.sub_total_amount)}</TableCell>
                        </TableRow>
                    }
                    {/* {
                        showDiscount &&
                        <TableRow>
                            <TableCell align="right" width={'90%'}>{t('discount')}</TableCell>
                            <TableCell align="right">{formatCurrencyDisplay(data?.document?.discount_amount)}</TableCell>
                        </TableRow>
                    } */}
                    {
                        (showDiscount && adjustmentDiscountInfo.length > 0) &&
                        <TableRow>
                            <TableCell align="right" width={'90%'}>{t('discount')}</TableCell>

                            {
                                adjustmentDiscountInfo.map(i => {
                                    return (
                                        (i?.discountAmount) ?
                                            <TableCell key={i?.discountId} align="right">
                                                {formatCurrencyDisplay(
                                                    parseFloat(i?.discountAmount).toFixed(2)
                                                )}
                                            </TableCell>
                                            :
                                            <TableCell>{"-"}</TableCell>
                                    )
                                })
                            }
                        </TableRow>
                    }
                    {
                        showTax &&

                        <>
                            {
                                adjustmentTaxInfo.map((i, index) => {
                                    return (
                                        <TableRow key={index}>
                                            <TableCell align="right" width={'90%'}>
                                                {`${t('tax')} - ${i?.taxDescription}`}
                                            </TableCell>

                                            <TableCell align="right">
                                                <Box key={i?.taxId}>
                                                    {formatCurrencyDisplay(
                                                        parseFloat(i?.taxAmount).toFixed(2)
                                                    )}
                                                </Box>
                                            </TableCell>

                                        </TableRow>

                                    )
                                })
                            }
                        </>

                        // <TableRow>
                        //     <TableCell align="right" width={'90%'}>
                        //         {t('tax')}
                        //         <Box>
                        //             {/* {data?.document?.tax_description} */}
                        //             {adjustmentTax?.adjustmentDescription}
                        //         </Box>
                        //     </TableCell>
                        //     {/* <TableCell align="right">{formatCurrencyDisplay(data?.document?.tax_amount)}</TableCell> */}
                        //     <TableCell align="right">{formatCurrencyDisplay(taxAmount)}</TableCell>
                        // </TableRow>
                    }
                    {
                        <>
                            {
                                adjustmentRoundingCredit.map((i, index) => {
                                    return (
                                        <TableRow key={index}>
                                            <TableCell align="right" width={'90%'}>
                                                {`${t('roundOffAmount')}`}
                                            </TableCell>

                                            <TableCell align="right">
                                                {
                                                    `+${formatCurrencyDisplay(parseFloat(i?.roundingAmount).toFixed(2))}`
                                                }
                                            </TableCell>

                                        </TableRow>

                                    )
                                })
                            }
                        </>
                    }

                    {
                        <>
                            {
                                adjustmentRoundingDebit.map((i, index) => {
                                    return (
                                        <TableRow key={index}>
                                            <TableCell align="right" width={'90%'}>
                                                {`${t('roundOffAmount')}`}
                                            </TableCell>

                                            <TableCell align="right">
                                                {
                                                    `-${formatCurrencyDisplay(parseFloat(i?.roundingAmount).toFixed(2))}`
                                                }
                                            </TableCell>

                                        </TableRow>

                                    )
                                })
                            }
                        </>
                    }

                    {
                        showTotalAmount &&
                        <TableRow>
                            <TableCell align="right" width={'90%'}>{t('totalAmount')} {currencyAbb}</TableCell>
                            <TableCell align="right">{formatCurrencyDisplay(data?.document?.total_amount)}</TableCell>
                        </TableRow>
                    }
                    {
                        customRows.map((i, index) => {
                            return (
                                <TableRow key={index}>
                                    <TableCell align="right" width={'90%'}>{i.label}</TableCell>
                                    <TableCell align="right">{i.display}</TableCell>
                                </TableRow>
                            )
                        })
                    }
                </TableBody>
            </Table>
        </TableContainer>
    )

}